module.exports = __webpack_public_path__ + "static/img/1.e18303d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/1.png
// module id = xsTL
// module chunks = 0